import axiosInstance from '../../config/axios.config';

/**
 * Company User Management Service
 *
 * Handles API calls for company admin to manage users and roles
 * within their company
 */
const companyUserManagementService = {
    /**
     * Get paginated user list with filters
     * @param {Object} params - Query parameters (page, per_page, search, role)
     * @returns {Promise}
     */
    getUserList: async (params = {}) => {
        try {
            const token = localStorage.getItem('authToken');

            if (token) {
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            const response = await axiosInstance.get('/company/users', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching company users:', error);
            throw error;
        }
    },

    /**
     * Update user role (company roles only)
     * @param {number} userId - User ID to update
     * @param {Object} roleData - { role: 'company_admin' | 'company_user' | 'company_manager' | 'company_auditor' }
     * @returns {Promise}
     */
    updateUserRole: async (userId, roleData) => {
        try {
            const token = localStorage.getItem('authToken');

            if (token) {
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            const response = await axiosInstance.patch(`/company/users/${userId}/role`, roleData);
            return response.data;
        } catch (error) {
            console.error('Error updating user role:', error);
            throw error;
        }
    },

    /**
     * Get available company-level roles
     * @returns {Promise}
     */
    getAvailableRoles: async () => {
        try {
            const token = localStorage.getItem('authToken');

            if (token) {
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }

            const response = await axiosInstance.get('/company/roles');
            return response.data;
        } catch (error) {
            console.error('Error fetching available roles:', error);
            throw error;
        }
    }
};

export default companyUserManagementService;
